import React, {useCallback, useEffect, useState} from "react";
import BasicGrid from "../../../grid/BasicGrid";
import {getCerts} from "../../../../service/dataService";
import {Button, ButtonToolbar, Stack, toaster, Tooltip, Whisper} from "rsuite";
import SuccessNotification from "../../../notifications/SuccessNotification";
import {
    CERT_ADD_ERROR,
    CERT_ADD_SUCCESS,
    CERT_EDIT_ERROR,
    CERT_EDIT_SUCCESS, CERT_MERGE_ERROR, CERT_MERGE_SUCCESS,
} from "../../../../service/constants";
import ErrorNotification from "../../../notifications/ErrorNotification";
import AddAdminCertModal from "../../../modals/admin/certs/AddAdminCertModal";
import EditAdminCertModal from "../../../modals/admin/certs/EditAdminCertModal";
import CertCleanupModal from "../../../modals/admin/certs/CertCleanupModal";

const defaultColumns = [
    {
        key: 'id',
        label: 'Id',
    },
    {
        key: 'certName',
        label: 'Certificate Name',
        flexGrow: 2,
    },
];

const AdminCerts = () => {
    const [certs, setCerts] = useState([]);
    const [loading, setLoading] = useState(false);

    // add modal
    const [addModalOpen, setAddModalOpen] = useState(false);

    // edit modal
    const [selectedCert, setSelectedCert] = useState({});
    const [editModalOpen, setEditModalOpen] = useState(false);

    // cleanup modal
    const [cleanupModalOpen, setCleanupModalOpen] = useState(false);


    // table
    const [columnKeys] = useState(defaultColumns.map(column => column.key));
    const columns = defaultColumns.filter(column => columnKeys.some(key => key === column.key));

    const getCertificates = useCallback(() => {
        setLoading(true);
        getCerts().then((data) => {
            setCerts(data);
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        getCertificates();
    }, [getCertificates]);

    const setClickedCert = useCallback((rowData) => {
        setEditModalOpen(true);
        setSelectedCert(rowData);
    },[]);

    const handleAddClose = useCallback(({result}) => {
        if(result === 'success') {
            toaster.push(<SuccessNotification message={CERT_ADD_SUCCESS} />, { placement: 'topCenter' });
            getCertificates();
        } else if (result === 'error') {
            toaster.push(<ErrorNotification message={CERT_ADD_ERROR} />, { placement: 'topCenter' });
        }
        setAddModalOpen(false);
    },[getCertificates]);

    const handleEditClose = useCallback(({result}) => {
        if(result === 'success') {
            toaster.push(<SuccessNotification message={CERT_EDIT_SUCCESS} />, { placement: 'topCenter' });
            getCertificates();
        } else if (result === 'error') {
            toaster.push(<ErrorNotification message={CERT_EDIT_ERROR} />, { placement: 'topCenter' });
        }
        setEditModalOpen(false);
    },[getCertificates]);

    const handleCleanupClose = useCallback(({result}) => {
        if(result === 'success') {
            toaster.push(<SuccessNotification message={CERT_MERGE_SUCCESS} />, { placement: 'topCenter' });
            getCertificates();
        } else if (result === 'error') {
            toaster.push(<ErrorNotification message={CERT_MERGE_ERROR} />, { placement: 'topCenter' });
        }
        setCleanupModalOpen(false);
    },[getCertificates]);

    return (
        <>
            <Stack spacing={2} direction='column' alignItems='flex-start' style={{paddingBottom: '0.5rem'}}>
                <p>Click to edit/delete certificates.</p>
                <p>
                    Changes/removal will cascade to all users with this current certificate.
                </p>
                <p>
                    <b>Warning:</b> Deleting the certificate will delete it for all users.
                </p>
            </Stack>
            <ButtonToolbar>
                <Button appearance="primary"
                        onClick={() => setAddModalOpen(true)}
                        style={{marginBottom: '1rem'}}
                >
                    Add Certificate
                </Button>
                <Whisper
                    trigger="hover"
                    speaker={<Tooltip>The Cert Cleanup allows easy data curation</Tooltip>}
                    placement="top"
                >
                    <Button
                        appearance="primary"
                        style={{marginBottom: '1rem'}}
                        onClick={() => setCleanupModalOpen(true)}
                    >
                        Cert Cleanup
                    </Button>
                </Whisper>
            </ButtonToolbar>
            <BasicGrid
                loading={loading}
                columns={columns}
                data={certs}
                handleClick={setClickedCert}
                exportTitle="admin-cert-list"
            />
            <AddAdminCertModal
                open={addModalOpen}
                handleClose={handleAddClose}
            />
            <EditAdminCertModal
                open={editModalOpen}
                handleClose={handleEditClose}
                selectedCert={selectedCert}
            />
            <CertCleanupModal
                open={cleanupModalOpen}
                handleClose={handleCleanupClose}
                certs={certs}
            />
        </>
    );
};

export default AdminCerts;